import React from 'react';
import styles from './styles/toggle-tab.module.css';

export default function ToggleTab({ width, optionMap, selectedOption, handleClick }) {
    return (
        <div className={styles.wrapper} style={{ width }}>
            {optionMap.map((option, index) => {
                const isSelected = option.value === selectedOption;

                const iconToRender = isSelected ? option.activeIcon : option.icon;

                return (
                    <button
                        key={option.value}
                        className={styles.button}
                        data-type={isSelected ? 'active' : 'inactive'}
                        data-order={index === 0 ? 'left' : 'right'}
                        onClick={() => handleClick(option.value)}
                    >
                        {iconToRender && <span>{iconToRender}</span>}
                        <span>{option.name}</span>
                    </button>
                );
            })}
        </div>
    );
}
